// import components
import { styled, Skeleton, SkeletonProps } from '@mui/material';

export const StyledReadModeSkeleton = styled(Skeleton)<SkeletonProps>(
  ({ theme }) => ({
    width: '100%',
    height: theme.spacing(9)
  })
);
